import React, {Component} from 'react';
import {connect} from 'react-redux';
// utils
import {formApiUrl,Translations} from '../../../../../utils';
// constant
import {FORM_REFS} from '../../../../../constants';
// restClient
import {aemHostClient, eapiClient} from '../../../../../restClient';
// children
import Dynamicform from '../../../../common/Dynamicform/dynamicForm';
import {blockUi, unBlockUi} from '../../../../../actions/actionCreator';


//import './AddOtherAccount.css';
class AddIEOtherAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_gls-add-other-account-hsbc-ie";
     if(this.props.mode === "edit") {
      apiURL = apiURL.replace("json_gls-add-", "json_gls-edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({formJson: data});
    });
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  onFormSubmit = (event, apiURL) => {
    this.props.blockUi();
    var {productId} = this.props.match.params;
    var requestData = {
      ...this.state.formData,
      bankName:'HSBC',
      hsbcAccount: 'hsbc'
    };

    if(this.props.mode === 'edit') {
      apiURL = this.translations(apiURL) + "/" + this.state.formData.id;
    }else {
      apiURL = this.translations(apiURL)
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(formApiUrl(apiURL, ":glsId", productId), {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
    .then(({data}) => {
      var key = window.sessionStorage.getItem("getCurrentDropDown");
      window.sessionStorage.setItem('key'+ key, JSON.stringify({...data.responseData.otherAccounts[data.responseData.otherAccounts.length-1]}));
      this.props.history.goBack();
      this.props.unBlockUi();
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData;
    const savedPageStateString = window.sessionStorage.getItem("previousPageState");
    const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) :''

    if(this.props.currentOtherAccount !== undefined) {
      formData = {...this.props.currentOtherAccount};
    }else {
      formData = {};
    }
    const properties = {
      accountId: this.props.match.params.accountId,
      formData,
      editType: 'create-new-ie-other-account',
      pathname: this.props.history.location.pathname,
      setCountry: savedPageState.selectedCountry
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      return (
        <Dynamicform mode={this.props.mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        forceValidations={this.props.mode === 'edit' ? false : true}
        history={this.props.history}
        match={this.props.match}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang={this.props.lang.currentLang.lang}
        translatedData={this.props.lang.translatedData}
        />
      );
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">{this.translations(pageTitle.pageHeading)}</h2>
      <p className="form-required-desc">{this.translations(pageTitle.descriptionText)}</p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state,props) => {
  let currentOtherAccount = undefined;
  if(props.match.params) {
    var {otherAccountId} = props.match.params;
    if(otherAccountId && state.currentProductInterestEnhancement.accounts.length > 0){
      state.currentProductInterestEnhancement.accounts.forEach(otherAccount => {
        if(otherAccount.id === otherAccountId) {
          currentOtherAccount = otherAccount;
        }
      });
    }
  }
  return {
    currentOtherAccount,
    mode: currentOtherAccount !== undefined ? 'edit' : '',
    myState: state,
    lang: state.lang
  };
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddIEOtherAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/AddCountyAndAccount/AddIEOtherAccount.js